<div
    *ngIf="message"
    [ngClass]="{
        alert: !!message,
        'alert-warning': messageType === 'warning',
        'alert-danger': messageType === 'error'
    }"
    class="container"
    [class]="containerClass"
>
    <ng-container *ngIf="hasHtmlTag; else plainMessage">
        <mat-icon class="icon">{{ messageType }}</mat-icon>
        <p class="message" [innerHTML]="message"></p>
    </ng-container>
    <ng-template #plainMessage>
        <mat-icon class="icon">{{ messageType }}</mat-icon>
        <p class="message">{{ message }}</p>
    </ng-template>
</div>
